import { DateTime } from 'luxon';

const _databaseFormat = 'yyyy-MM-dd HH:mm:ss';
const _shortDatabaseFormat = 'yyyy-MM-dd';
const _galleryDateDisplayFormat = 'LLL dd, yyyy';

const fromSQL = (date: string): DateTime => {
  return DateTime.fromFormat(date, _databaseFormat);
};

const fromShortSQL = (date: string): DateTime => {
  return DateTime.fromFormat(date, _shortDatabaseFormat);
};

const descending = (a: DateTime, b: DateTime): number => {
  if (a < b) return 1;
  else if (a > b) return -1;
  return 0;
};

export const DateService = {
  fromSQL,
  fromShortSQL,
  descending,
  databaseFormat: _databaseFormat,
  shortDatabaseFormat: _shortDatabaseFormat,
  galleryDateDisplayFormat: _galleryDateDisplayFormat,
};
